import { PendingCreate, PendingDelete } from "./types"

export const QUEUE_CREATE = "profilePermissionQueue/QUEUE_CREATE";
export const CANCEL_CREATE = "profilePermissionQueue/CANCEL_CREATE";
export const QUEUE_DELETE = "profilePermissionQueue/QUEUE_DELETE";
export const CANCEL_DELETE = "profilePermissionQueue/CANCEL_DELETE";
export const CLEAR_QUEUES = "profilePermissionQueue/CLEAR_QUEUES";

export const queueCreate = (payload: PendingCreate) => ({
  type: QUEUE_CREATE,
  payload,
});
export const cancelCreate = (payload: {
  optionId: number | string;
  actionId: number | string;
}) => ({
  type: CANCEL_CREATE,
  payload,
});

export const queueDelete = (payload: PendingDelete) => ({
  type: QUEUE_DELETE,
  payload,
});
export const cancelDelete = (payload: {
  optionId: number | string;
  actionId: number | string;
}) => ({
  type: CANCEL_DELETE,
  payload,
});

export const clearQueues = () => ({ type: CLEAR_QUEUES });
